<template>
  <div class="container">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div
      v-if="serviceOrder.patId === 0"
      class="header"
    >
      <Message
        severity="error"
        :closable="false"
        icon="pi-exclamation-triangle"
      >
        <span class="p-d-flex p-ai-center p-jc-between">
          <span> Ordem de serviço sem PAT </span>
          <Button
            v-if="can('createPatFromExtranetServiceOrder')"
            label="Criar"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-info"
            @click="createPat(serviceOrder.id)"
          />
        </span>
      </Message>
    </div>
    <div class="content">
      <div class="p-fluid p-formgrid p-grid">
        <!-- PAT -->
        <div
          v-if="serviceOrder.patId !== 0"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="pat_id"
              name="pat_id"
              type="text"
              v-model="serviceOrder.patId"
              :disabled="true"
            />
            <label for="pat_id">PAT</label>
          </span>
        </div>
        <!-- Service Order -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="id"
              name="id"
              type="text"
              v-model="serviceOrder.id"
              :disabled="true"
            />
            <label for="id">Ordem de Serviço</label>
          </span>
        </div>
        <!-- Date -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="request_date"
              name="request_date"
              type="text"
              v-model="serviceOrder.created_at"
              :disabled="true"
            />
            <label for="request_date">Data da Solicitação</label>
          </span>
        </div>
      </div>
      <!-- Client -->
      <hr />
      <div>Cliente</div>
      <div class="p-fluid p-formgrid p-grid">
        <!-- Name -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_name"
              name="client_name"
              type="text"
              v-model="serviceOrder.client.name"
              :disabled="true"
            />
            <label for="client_name">Nome</label>
          </span>
        </div>
        <!-- Email -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_email"
              name="client_email"
              type="text"
              v-model="serviceOrder.client.email"
              :disabled="true"
            />
            <label for="client_email">Email</label>
          </span>
        </div>
        <!-- Contact 1 -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_contact_1"
              name="client_contact_1"
              type="text"
              v-model="serviceOrder.client.telephone"
              :disabled="true"
            />
            <label for="client_contact_1">Contacto 1</label>
          </span>
        </div>
        <!-- Contact 2 -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_contact_2"
              name="client_contact_2"
              type="text"
              v-model="serviceOrder.client.mobilPhone"
              :disabled="true"
            />
            <label for="client_contact_2">Contacto 2</label>
          </span>
        </div>
        <!-- Address -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_address"
              name="client_address"
              type="text"
              v-model="serviceOrder.client.address"
              :disabled="true"
            />
            <label for="client_address">Morada</label>
          </span>
        </div>
        <!-- Zip Code -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_zipcode"
              name="client_zipcode"
              type="text"
              v-model="serviceOrder.client.zipCode"
              :disabled="true"
            />
            <label for="client_zipcode">Codigo Postal</label>
          </span>
        </div>
        <!-- City -->
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="client_city"
              name="client_city"
              type="text"
              v-model="serviceOrder.client.city"
              :disabled="true"
            />
            <label for="client_city">Cidade</label>
          </span>
        </div>
      </div>
      <!-- Entity -->
      <hr v-if="serviceOrder.entity" />
      <div v-if="serviceOrder.entity">Entidade</div>
      <div
        v-if="serviceOrder.entity"
        class="p-fluid p-formgrid p-grid">
        <!-- Name -->
        <div
          v-if="serviceOrder.entity?.name"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_name"
              name="entity_name"
              type="text"
              v-model="serviceOrder.entity.name"
              :disabled="true"
            />
            <label for="entity_name">Nome</label>
          </span>
        </div>
        <!-- Email -->
        <div
          v-if="serviceOrder.entity?.email"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_email"
              name="entity_email"
              type="text"
              v-model="serviceOrder.entity.email"
              :disabled="true"
            />
            <label for="entity_email">Email</label>
          </span>
        </div>
        <!-- Contact 1 -->
        <div
          v-if="serviceOrder.entity?.telephone"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_contact_1"
              name="entity_contact_1"
              type="text"
              v-model="serviceOrder.entity.telephone"
              :disabled="true"
            />
            <label for="entity_contact_1">Contacto 1</label>
          </span>
        </div>
        <!-- Contact 2 -->
        <div
          v-if="serviceOrder.entity?.mobilPhone"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_contact_2"
              name="entity_contact_2"
              type="text"
              v-model="serviceOrder.entity.mobilPhone"
              :disabled="true"
            />
            <label for="entity_contact_2">Contacto 2</label>
          </span>
        </div>
        <!-- Address -->
        <div
          v-if="serviceOrder.entity?.address"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_address"
              name="entity_address"
              type="text"
              v-model="serviceOrder.entity.address"
              :disabled="true"
            />
            <label for="entity_address">Morada</label>
          </span>
        </div>
        <!-- Zip Code -->
        <div
          v-if="serviceOrder.entity?.zip_code"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_zipcode"
              name="entity_zipcode"
              type="text"
              v-model="serviceOrder.entity.zip_code"
              :disabled="true"
            />
            <label for="entity_zipcode">Codigo Postal</label>
          </span>
        </div>
        <!-- City -->
        <div
          v-if="serviceOrder.entity?.city"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="entity_city"
              name="entity_city"
              type="text"
              v-model="serviceOrder.entity.city"
              :disabled="true"
            />
            <label for="entity_city">Cidade</label>
          </span>
        </div>
      </div>
      <!-- Equipment -->
      <hr />
      <div>Equipamento</div>
      <div class="p-fluid p-formgrid p-grid">
        <!-- Brand -->
        <div
          v-if="serviceOrder.equipment?.brand"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="equipment_name"
              name="equipment_name"
              type="text"
              v-model="serviceOrder.equipment.brand"
              :disabled="true"
            />
            <label for="equipment_name">Marca</label>
          </span>
        </div>
        <!-- Model -->
        <div
          v-if="serviceOrder.equipment?.model"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="equipment_model"
              name="equipment_model"
              type="text"
              v-model="serviceOrder.equipment.model"
              :disabled="true"
            />
            <label for="equipment_model">Modelo</label>
          </span>
        </div>
        <!-- Serial Number -->
        <div
          v-if="serviceOrder.equipment?.serialNumber"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="equipment_serialNumber"
              name="equipment_serialNumber"
              type="text"
              v-model="serviceOrder.equipment.serialNumber"
              :disabled="true"
            />
            <label for="equipment_serialNumber">Número de Série</label>
          </span>
        </div>
        <!-- Type -->
        <div
          v-if="serviceOrder.equipment?.type"
          class="p-col-12 p-md-12 p-mt-5"
        >
          <span class="p-float-label">
            <InputText
              id="equipment_type"
              name="equipment_type"
              type="text"
              v-model="serviceOrder.equipment.mobilPhone"
              :disabled="true"
            />
            <label for="equipment_type">Tipo</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceOrdersService from "../../services/serviceOrders.service";
export default {
  name: "DetailExtranet",
  props: ["serviceOrder"],
  methods: {
    async createPat(id) {
      this.loading = true
      try {
        await serviceOrdersService.serviceOrderExtranetCreatePat(id)
        this.$toast.add({
          severity: "success",
          summary: `PAT criada com sucesso.`,
          detail: ``,
          life: 3000,
        });
        this.$emit("pat-created");
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: `Falha ao criar PAT`,
          detail: ``,
          life: 3000,
        });
      } finally {
        this.loading = false
      }
    },
  },
};
</script>
<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  overflow: auto;
  padding: 10px;
}
</style>
<style lang="css" scoped>
:deep(.p-message-text) {
  width: 100% !important;
}
</style>
